var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { size: "large", spinning: _vm.loading } },
    [
      _c("common-layout", [
        _c("div", { staticClass: "main-login" }, [
          !_vm.isMobile
            ? _c("div", { staticClass: "left" }, [
                _c("div", { staticClass: "left-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("svg-icon", {
                        staticClass: "logo",
                        staticStyle: {
                          width: "309px",
                          height: "44px",
                          background: "none",
                        },
                        attrs: { iconClass: "login" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "left-img" },
                    [
                      _c(
                        "a-carousel",
                        { attrs: { autoplay: "", dotsClass: "dots" } },
                        [
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login1.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login2.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login3.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login4.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login5.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login6.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login7.png"),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "login" }, [
              _c("div", { staticClass: "title", class: [_vm.lang] }, [
                _vm._v(" " + _vm._s(_vm.$t("resetYourPwd")) + " "),
              ]),
              _c("div", { staticClass: "subTitle", class: [_vm.lang] }, [
                _vm._v(" " + _vm._s(_vm.$t("InputNewPwd")) + " "),
              ]),
              _c(
                "div",
                { staticClass: "wrapForm" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: {
                        layout: "vertical",
                        form: _vm.form,
                        size: "large",
                      },
                    },
                    [
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("newPwd"))),
                      ]),
                      _c(
                        "a-form-item",
                        {
                          class: [_vm.lang],
                          attrs: {
                            "validate-status": _vm.passwordError()
                              ? "error"
                              : "",
                            help: _vm.passwordError() || "",
                          },
                        },
                        [
                          _c(
                            "a-input-password",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "password",
                                    {
                                      trigger: ["blur", "change"],
                                      rules: [
                                        {
                                          required: true,
                                          validator: function (
                                            rule,
                                            value,
                                            callback
                                          ) {
                                            // 检查密码长度是否少于 8 个字符
                                            if (value.length < 8) {
                                              callback(_vm.$t("charactersDes"))
                                              return
                                            }

                                            // 检查是否包含大写字母
                                            if (!/[A-Z]/.test(value)) {
                                              callback(
                                                _vm.$t("uppercaseCharacter")
                                              )
                                              return
                                            }

                                            // 检查是否包含小写字母
                                            if (!/[a-z]/.test(value)) {
                                              callback(
                                                _vm.$t("lowercaseCharacter")
                                              )
                                              return
                                            }

                                            // 检查是否包含数字
                                            if (!/[0-9]/.test(value)) {
                                              callback(_vm.$t("digitRequired"))
                                              return
                                            }
                                            // 检查是否包含特殊字符
                                            if (!_vm.reg.test(value)) {
                                              callback(
                                                _vm.$t("specialCharacter")
                                              )
                                              return
                                            }
                                            callback()
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  expression:
                                    "[\n                    'password',\n                    {\n                      trigger: ['blur', 'change'],\n                      rules: [\n                        {\n                          required: true,\n                          validator: function (rule, value, callback) {\n                            // 检查密码长度是否少于 8 个字符\n                            if (value.length < 8) {\n                              callback($t('charactersDes'));\n                              return;\n                            }\n\n                            // 检查是否包含大写字母\n                            if (!/[A-Z]/.test(value)) {\n                              callback($t('uppercaseCharacter'));\n                              return;\n                            }\n\n                            // 检查是否包含小写字母\n                            if (!/[a-z]/.test(value)) {\n                              callback($t('lowercaseCharacter'));\n                              return;\n                            }\n\n                            // 检查是否包含数字\n                            if (!/[0-9]/.test(value)) {\n                              callback($t('digitRequired'));\n                              return;\n                            }\n                            // 检查是否包含特殊字符\n                            if (!reg.test(value)) {\n                              callback($t('specialCharacter'));\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                    },\n                  ]",
                                },
                              ],
                              attrs: { placeholder: _vm.$t("newPwd") },
                            },
                            [
                              _c("a-icon", {
                                staticStyle: { color: "rgba(0, 0, 0, 0.25)" },
                                attrs: { slot: "prefix", type: "lock" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                          _vm.isSignUp &&
                          !_vm.passwordError() &&
                          !_vm.getPasswordValue()
                            ? _c("div", { staticClass: "info-tips" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("passwordDes")) + " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("confirmNewPwd"))),
                      ]),
                      _c(
                        "a-form-item",
                        {
                          class: [_vm.lang],
                          attrs: {
                            "validate-status": _vm.password2Error()
                              ? "error"
                              : "",
                            help: _vm.password2Error() || "",
                          },
                        },
                        [
                          _c(
                            "a-input-password",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "password2",
                                    {
                                      trigger: ["blur", "change"],
                                      rules: [
                                        {
                                          required: true,
                                          validator: function (
                                            rule,
                                            value,
                                            callback
                                          ) {
                                            // 检查密码长度是否少于 8 个字符
                                            if (value.length < 8) {
                                              callback(_vm.$t("charactersDes"))
                                              return
                                            }

                                            // 检查是否包含大写字母
                                            if (!/[A-Z]/.test(value)) {
                                              callback(
                                                _vm.$t("uppercaseCharacter")
                                              )
                                              return
                                            }

                                            // 检查是否包含小写字母
                                            if (!/[a-z]/.test(value)) {
                                              callback(
                                                _vm.$t("lowercaseCharacter")
                                              )
                                              return
                                            }

                                            // 检查是否包含数字
                                            if (!/[0-9]/.test(value)) {
                                              callback(_vm.$t("digitRequired"))
                                              return
                                            }
                                            // 检查是否包含特殊字符
                                            if (!_vm.reg.test(value)) {
                                              callback(
                                                _vm.$t("specialCharacter")
                                              )
                                              return
                                            }
                                            if (
                                              value !== _vm.getPasswordValue()
                                            ) {
                                              callback(
                                                _vm.$t(_vm.$t("notMatch"))
                                              )
                                              return
                                            }
                                            callback()
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  expression:
                                    "[\n                    'password2',\n                    {\n                      trigger: ['blur', 'change'],\n                      rules: [\n                        {\n                          required: true,\n                          validator: function (rule, value, callback) {\n                            // 检查密码长度是否少于 8 个字符\n                            if (value.length < 8) {\n                              callback($t('charactersDes'));\n                              return;\n                            }\n\n                            // 检查是否包含大写字母\n                            if (!/[A-Z]/.test(value)) {\n                              callback($t('uppercaseCharacter'));\n                              return;\n                            }\n\n                            // 检查是否包含小写字母\n                            if (!/[a-z]/.test(value)) {\n                              callback($t('lowercaseCharacter'));\n                              return;\n                            }\n\n                            // 检查是否包含数字\n                            if (!/[0-9]/.test(value)) {\n                              callback($t('digitRequired'));\n                              return;\n                            }\n                            // 检查是否包含特殊字符\n                            if (!reg.test(value)) {\n                              callback($t('specialCharacter'));\n                              return;\n                            }\n                            if (value !== getPasswordValue()) {\n                              callback($t($t('notMatch')));\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                    },\n                  ]",
                                },
                              ],
                              attrs: { placeholder: _vm.$t("confirmNewPwd") },
                            },
                            [
                              _c("a-icon", {
                                staticStyle: { color: "rgba(0, 0, 0, 0.25)" },
                                attrs: { slot: "prefix", type: "lock" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-button",
                            {
                              staticStyle: { width: "60%" },
                              attrs: {
                                type: "primary",
                                "html-type": "submit",
                                disabled:
                                  _vm.hasErrors(_vm.form.getFieldsError()) ||
                                  !_vm.haveFormValue()
                                    ? true
                                    : false,
                              },
                              on: { click: _vm.onSubmit },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("resetPwd")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }